// frontend/src/store.js
// Purpose: Configure Redux store with appropriate middleware.
// Desired purpose: Provides a single Redux store for the entire application, 
//                  including the newly refactored "analysis" slice.

// Import dependencies
import { configureStore } from '@reduxjs/toolkit';

// Import the combined analysis slice reducer from its new location
import analysisReducer from './state/analysis/analysisSlice';

// Configure and export the Redux store
const store = configureStore({
  reducer: {
    // "analysis" is the key used in Redux state
    analysis: analysisReducer
    // Add more reducers here if needed
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // If you have non-serializable values in your analysis slice actions,
        // specify them here to avoid Redux Toolkit warnings.
        ignoredActions: ['analysis/updateProgress/fulfilled'],
        ignoredActionPaths: ['meta.arg', 'payload.timestamp'],
        ignoredPaths: ['analysis.uploadedFiles.file'],
      },
    }),
  // Enable Redux DevTools only in development mode
  devTools: process.env.NODE_ENV !== 'production',
});

export default store;